export function moveCourseTest(tests, index, delta) {
  if (!Array.isArray(tests)) {
    return null;
  }
  const target = index + delta;
  if (index < 0 || index >= tests.length || target < 0 || target >= tests.length) {
    return null;
  }
  const next = [...tests];
  const [item] = next.splice(index, 1);
  next.splice(target, 0, item);
  return next;
}

export function moveCourseTestToIndex(tests, index, target) {
  if (!Array.isArray(tests)) {
    return null;
  }
  if (index < 0 || index >= tests.length || target < 0 || target >= tests.length || index === target) {
    return null;
  }
  const next = [...tests];
  const [item] = next.splice(index, 1);
  next.splice(target, 0, item);
  return next;
}

export function resolveMovedEditingIndex(currentEditingIndex, movedIndex, delta) {
  if (currentEditingIndex === undefined || currentEditingIndex === null) {
    return currentEditingIndex;
  }
  const target = movedIndex + delta;
  if (currentEditingIndex === movedIndex) {
    return target;
  }
  if (currentEditingIndex === target) {
    return movedIndex;
  }
  return currentEditingIndex;
}

export function resolveEditingIndexAfterMove(currentEditingIndex, movedIndex, targetIndex) {
  if (currentEditingIndex === undefined || currentEditingIndex === null) {
    return currentEditingIndex;
  }
  if (currentEditingIndex === movedIndex) {
    return targetIndex;
  }
  const start = Math.min(movedIndex, targetIndex);
  const end = Math.max(movedIndex, targetIndex);
  if (currentEditingIndex < start || currentEditingIndex > end) {
    return currentEditingIndex;
  }
  return movedIndex < targetIndex ? currentEditingIndex - 1 : currentEditingIndex + 1;
}
